<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="card shadow-sm">
      <div class="card-header">
        <h3>Survey list</h3>
      </div>

      <div class="card-body">
        <div>
          <div class="card-body" style="padding:0;">
            <div>
              <!-- Btn Group : Deletion -->
              <button type="button" style="margin-bottom: 10px; margin-right: 0px; float: right;" class="btn btn-danger"
                @click="deleteSurveys()" v-bind:disabled="blDelBtnAvl == false">DELETE</button>
              <!-- Btn Group : Creation -->
              <button type="button" style="margin-bottom: 10px; margin-right: 5px; float: right;" class="btn btn-primary"
                @click="$router.push('/survey/new')">CREATE</button>
              <!-- Btn Group : Comparision -->
              <!-- <button type="button" style="margin-bottom: 10px;  float: left;" class="btn btn-success"
              @click="showSurveyComparision()" v-bind:disabled="blCompbtnAvl == false">Comparision</button> -->
              <!-- Btn Group : word Cloud -->
              <button type="button" v-b-modal.fileInput style="margin-bottom: 10px; margin-left:5px; float: left;"
                class="btn btn-success">Word Cloud</button>

              <div>
                <b-form-group>
                  <b-modal ref="myModal" id="fileInput" title="Add a file" :hide-footer="true" @hide="handleModalHide">
                    <label for="field">Field <span class="required">*</span></label>
                    <b-form-input label="field" v-model="field"></b-form-input>
                    <!-- File -->
                    <label>File <span class="required">*</span></label>
                    <b-form-file multiple ref="file-input" id="file-input" name="file" v-model="fileInput"
                      placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"></b-form-file>
                    <!-- /File -->
                    <b-button class="mt-4" variant="success" block @click="uploadWordCloud()" 
                      :disabled="fileInput == null || fileInput.length == 0 || field == ''">Upload</b-button>
                  </b-modal>
                </b-form-group>
              </div>
              <!-- progress bar -->
              <div v-show="uploadPercentage > 0">
                <progress max="100" :value.prop="uploadPercentage"></progress>
              </div>
            </div>

            <table  class="table table-bordered table-hover shadow-sm mt-2">
              <colgroup>
                <col width="3%" />
                <col width="5%" />
                <col width="7%" />
                <col width="18%" />
                <col width="45%" />
                <col width="16%" />
                <col width="4%" />
              </colgroup>
              <thead class="script-header">
                <tr class="text-center">
                  <th><input type="checkbox" v-model="allChecked" @click="checkedAll($event.target.checked)" /></th>
                  <th>ID</th>
                  <th>SEQUENCE</th>
                  <th>PERIOD</th>
                  <th>SURVEY</th>
                  <th>CLIENT NAME</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in surveyList" :key="item.surveyId" @click="showSurveyDetail(item.surveyId)" style="cursor: pointer;">
                  <td class="text-center" @click.stop><input type="checkbox" :id="'check_' + item.surveyId" :value="item.surveyId"
                      v-model="item.selected" @change="selected($event)">
                  </td>
                  <td class="text-center">{{ item.surveyId}}</td>
                  <td class="text-center">{{ item.seq }}</td>
                  <td class="text-center">{{ item.startDate}} ~ {{ item.endDate }}</td>
                  <td>{{ item.title}}</td>
                  <td>{{ item.clientName}}</td>
                  <td class="text-center"><i style="font-size: 1.5em; color: DimGray;" class="fas fa-trash" type="button"
                      v-on:click="deleteSurvey(item.surveyId, item.surveyName)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <b-modal id="wordCloudMessageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary"
                 ok-title="Close">
            <p class="my-4 text-center">{{ msgContent }}</p>
      </b-modal>
      <div v-if="surveyList.length > 0 && surveyList.length != total
        ">
        <button class="btn btn-view-more" v-on:click="seeMore()" :disabled="surveyList.length == total">
          더보기 ({{ surveyList.length }} / {{ total }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      uploadPercentage: 0,
      files: [],
      paths: [],
      surveyList: [],
      total: 0,
      allChecked: false,
      blCompbtnAvl: false,
      blDelBtnAvl: false,
      fileInput: [],
      fileLoaded: false,
      field: '',
      msgStatus: '',
      msgContent: '',
    };
  },
  methods: {
    handleModalHide() {
      this.field = '';
      this.fileInput = [];
    },
    downloadBlob(blob, fileName) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE 및 Microsoft Edge 브라우저에서 다운로드
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // 다른 모든 브라우저에서 다운로드
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
      }
    },
    blobToString(blob) {
  const decoder = new TextDecoder("utf-8");
  return blob.arrayBuffer().then((buffer) => {
    const text = decoder.decode(buffer);
    return text;
  });
},
    async uploadWordCloud() {

      this.fileLoaded = true;
      let formData = new FormData();
      let file = this.fileInput[0];

      const clone = new File([file], file.name, { type: file.type });
      let fileInfo = {
        attachedFileId: '',
        attachedFilename: file.name,
        attachedFilePath: '',
        type: file.type,
        field : this.field,
        file: clone,
        new: true,
        deleted: false,
        url: '',
      };
      fileInfo.url = await this.createFileURL(fileInfo);
      formData.append('file', fileInfo.file);
      formData.append('field', fileInfo.field);
      try {
        this.isLoading = true;
        const response = await axios.post('survey/word-cloud/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: accessToken(),
        },
        responseType: 'blob', // Blob 응답 타입 설정
        });
      // 파일 다운로드
      const fileName = 'wordcloud.xlsx'; // 다운로드할 파일 이름
      this.downloadBlob(response.data, fileName);
      } catch (error) {
        if (error.status != 401) {
          if (error.response) {
                    this.msgStatus = error.response.status;
                }
                this.blobToString(error.response.data).then((result) => {this.msgContent = ( JSON.parse(result).message)});
                this.$bvModal.show('wordCloudMessageModal');
        }
      }finally{
        this.isLoading = false;
        this.fileInput = null;
        this.field = '';
        this.$refs.myModal.hide();
      }
    },
    async createFileURL(file) {
      try {
        let data = null;
        if (file.new && file.file) {
          data = file.file;
          return null;
        } else if (!file.new && file.attachedFilePath) {
          let response = await axios.get('chatter/image/' + file.attachedFileId, {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          });
          data = response.data;
        }
        return data ? URL.createObjectURL(data) : null;
      } catch (error) {
        await this.showError(error);
      }
    },
    showMessage(status, message) {
      this.msgStatus = status;
      this.msgContent = message;
      this.$bvModal.show("messageModal");
    },
    async retrieveSurveyList(serial) {
      try {
        this.isLoading = true;
        let params = {};

        if (serial != undefined) {
          params.serial = serial;
        }

        let response = await axios.post("survey/selectSurveyList", params, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        });
        let minSerial = Number.MAX_SAFE_INTEGER;
        let maxSerial = Number.MIN_SAFE_INTEGER;
        if (this.surveyList.length > 0) {
          maxSerial = this.surveyList[0].serial;
          minSerial = this.surveyList[this.surveyList.length - 1].serial;
        }
        // Push to surveyList if the serial does not fall between the min and the max serial
        response.data.list.forEach(item => {
          if (item.serial < minSerial || item.serial > maxSerial) {
            this.surveyList.push(item);
          }
        });
        // Sort surveys in descending order
        this.surveyList.sort((a, b) => b.serial - a.serial);
        this.total = response.data.total;
      } catch (error) {
        if (error.status != 401) {
          this.showMessage(
            error.status == 200 ? error.code : error.status,
            error.message
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
    async deleteSurvey(surveyId, surveyName) {
      // Confirm deletion
      let confirmed = await this.$bvModal.msgBoxConfirm("삭제하시겠습니까?", { title: "Confirm" });
      if (!confirmed) return;

      try {
        this.isLoading = true;

        await axios
          .post("survey/deleteSurvey/", {}, {
            params: { surveyId },
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          })
        this.showMessage(0, surveyName + "(" + surveyId + ") 삭제 했습니다.");
        this.reloadretrieveSurveyList();
      } catch (error) {
        if (error.status != 401) {
          this.showMessage(
            error.status == 200 ? error.code : error.status,
            error.message
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
    async deleteSurveys() {
      let surveyIds = this.getSelected();
      let surveyAmt = surveyIds.length;

      if (surveyAmt < 1) return;

      let confirmed = await this.$bvModal.msgBoxConfirm(surveyAmt + '개의 서베이를 삭제하시겠습니까?', { title: 'Confirm' });
      if (!confirmed) return;
      try {
        this.isLoading = true;

        await axios
          .post("survey/deleteSurveys/", {}, {
            params: { surveyIds },
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          })
        this.showMessage(0, surveyAmt + '개의 서베이를 삭제하였습니다.');
        this.reloadretrieveSurveyList();
      } catch (error) {
        if (error.status != 401) {
          this.showMessage(
            error.status == 200 ? error.code : error.status,
            error.message
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
    showSurveyDetail(surveyId) {
      this.$router.push({ name: "surveyDetail", params: { id: surveyId } });
    },
    // Survye Comparison
    showSurveyComparision() {
      let surveyIds = this.getSelected();
      if (surveyIds.length != 2) {
        return;
      }
      this.$router.push({ name: "surveyVisualizedComparison", params: { id: surveyIds } });
    },
    reloadretrieveSurveyList() {
      this.surveyList = [];
      this.total = 0;
      this.retrieveSurveyList();
    },
    seeMore() {
      this.retrieveSurveyList(
        this.surveyList[this.surveyList.length - 1].serial
      );
    },
    chkListMod() {
      let intSeletedAmt = this.getSelected().length
      if (intSeletedAmt > 0) {
        this.blDelBtnAvl = true;
      }
      if (intSeletedAmt == 2) {
        this.blCompbtnAvl = true;
      } else {
        this.blCompbtnAvl = false;
      }
    },
    checkedAll(checked) {
      this.allChecked = checked;
      for (let i in this.surveyList) {
        this.surveyList[i].selected = this.allChecked;
      }
      this.chkListMod();
    },
    selected() {
      this.chkListMod();
      for (let i in this.surveyList) {
        if (!this.surveyList[i].selected) {
          this.allChecked = false;
          return;
        } else {
          this.allChecked = true;
        }
      }
    },
    getSelected() {
      let surveyIds = [];
      for (let i in this.surveyList) {
        if (this.surveyList[i].selected) {
          surveyIds.push(this.surveyList[i].surveyId);
        }
      }

      return surveyIds;
    },
  },
  created() {
    this.retrieveSurveyList();
  },
};
</script>
<style>
span.required {
  color: red;
}
</style>